import React, { useEffect, useMemo, useState } from "react";

import { Button, ButtonGroup, Pager } from "bootstrap-micro";

import DatePicker from "app/VendoredDatePicker.jsx";

import { getEventIcon } from "../../const.js";
import { formatUTCString, minDate } from "../../../dateutils.js";
import { DEFAULT_END_DATE, DEFAULT_START_DATE, useEventsBasedOnRouter } from "../../store/eventsSlice.js";
import { useRouteMatch } from "react-router";
import { useLastEventSeen } from "../../store/sitesSlice.js";

const EVENT_TYPES = {
    all: "All",
    fire: "Fire",
    fault: "Fault",
    system: "System",
    service: "Service",
    technical: "Technical",
};

const PER_PAGE = 20;

export const EventsTab = () => {
    const [type, setType] = useState("all");
    const [activePage, setActivePage] = useState(1);

    const match = useRouteMatch();
    const lastSeen = useLastEventSeen(match.params.hwaddr);


    // const [startDate, setStartDate ] = useState(() => minDate(DEFAULT_START_DATE, lastSeen).toDate().toISOString().split("T")[0] );
    const [startDate, setStartDate ] = useState(DEFAULT_START_DATE);
    const [endDate, setEndDate ] = useState( DEFAULT_END_DATE);

    const events = useEventsBasedOnRouter(startDate, endDate);

    let filteredEvents = useMemo(
        () => events.filter(ev => ev.category == type || type == "all"), 
        [startDate, endDate, events]
    );

    //Reset pagination on search change
    useEffect(() => {
        if(activePage > 1){
            setActivePage(1);
        }
    }, [startDate, endDate, type]);

    const PAGE_COUNT = Math.ceil(filteredEvents.length / PER_PAGE);

    return (
        <div>
            <form className="events-filter clearfix">
                <ButtonGroup
                    className="col-md-6 col-sm-6 col-xs-12"
                    data-toggle="radio"
                    id="eventTypeFilter"
                >
                    {Object.keys(EVENT_TYPES).map((key) => (
                        <Button
                            key={key}
                            type="button"
                            className={key == type ? "btn-primary" : null}
                            onClick={() => setType(key)}
                        >
                            {EVENT_TYPES[key]}
                        </Button>
                    ))}
                </ButtonGroup>
                <div className="form-group col-md-5 col-sm-6 col-xs-12">
                    <div id="event-date-filter" className="input-daterange input-group">
                        <DatePicker
                            dateFormat="DD/MM/YYYY"
                            showClearButton={false}
                            value={startDate}
                            onChange={(ev) =>{

                                setStartDate(ev.split("T")[0]);
                                // TODO - Trigger a reload of events
                            }
                            }
                        />
                        <div className="input-group-addon">to</div>
                        <DatePicker
                            dateFormat="DD/MM/YYYY"
                            showClearButton={false}
                            value={endDate}
                            onChange={(ev) =>{
                                setEndDate(ev.split("T")[0])
                                // TODO - Trigger a reload
                            }
                            }
                        />
                    </div>
                </div>
            </form>

            {filteredEvents.length == 0 ? (
                <div className="alert alert-warning">
                    <h4>No Panel Events Found.</h4>
                    <p>No events found matching your search criteria.</p>
                </div>
            ) : (
                <div className="eventsPanel">
                    {filteredEvents
                        .slice(
                            (activePage - 1) * PER_PAGE,
                            activePage * PER_PAGE
                        )
                        .map((ev) => (
                            <EventRow
                                key={ev.id}
                                value={ev}
                            />
                        ))}
                    <div className="text-center">
                        <Pager>
                            <Pager.Item
                                previous
                                onClick={() =>
                                    setActivePage(activePage + 1 )
                                }
                                disabled={activePage == PAGE_COUNT}
                                href="#"
                            >
                Previous
                            </Pager.Item>
                            <li style={{ lineHeight: "32px" }}>
                                {activePage} / {PAGE_COUNT}
                            </li>
                            <Pager.Item
                                next
                                onClick={() =>
                                    setActivePage(activePage - 1)
                                }
                                disabled={activePage == 1}
                                href="#"
                            >
                Next
                            </Pager.Item>
                        </Pager>
                    </div>
                </div>
            )}
        </div>
    );
};

export function EventRow(props) {
    let eventSrc = null;
    if (Object.keys(EVENT_TYPES).indexOf(props.value.category) != -1) {
        try {
            eventSrc = getEventIcon(props.value.category);
        } catch (e) {
            console.error(e);
        }
    }
    return (
        <div className="panel panel-info" key={props.value.id}>
            <div className="row panel-body added-wordwrap">
                <div className="col-sm-1 col-xs-2">
                    {eventSrc ? <img src={eventSrc} className="event-icon" /> : null}
                </div>
                <div className="col-sm-4 col-xs-10">({props.value.networkId}) {props.value.title}</div>
                <div className="col-sm-3 col-xs-12">
                    {formatUTCString(props.value.date)}
                </div>
                <div className="col-sm-4 col-xs-12">
                    {["No location", "N/A"].indexOf(props.value.location) == -1
                        ? props.value.location
                        : ""}
                </div>
            </div>
        </div>
    );
}

export default EventsTab;
